import React, { useState } from "react";

// Fallback images per category (used when a crawled og:image is blocked/expired/404)
// Small widths — these render inside cards (~320px × 2 DPR).
const F = (id) => `https://images.unsplash.com/photo-${id}?auto=format&cs=srgb&fm=jpg&q=70&w=640`;
const FALLBACKS = {
  "onde-comer": F("1551809727-fa6cc87641a8"),
  eventos: F("1470229722913-7c0e2dbbafd3"),
  promocoes: F("1580828343064-fde4fc206bc6"),
  hoteis: F("1582719508461-905c673771fd"),
  praias: F("1541417904950-b855846fe074"),
  turismo: F("1699019493395-8a1f0c7883a9"),
  imoveis: F("1551361415-69c87624334f"),
  saude: F("1519494026892-80bbd2d6fd0d"),
  empregos: F("1543059080-f9b1272213d5"),
  empresas: F("1669308279799-29e105471c43"),
  noticias: F("1704659862301-b5420b437ac9"),
};
const DEFAULT_FALLBACK = FALLBACKS.noticias;

// Renders an image that gracefully degrades: broken/blocked src -> category fallback -> gradient.
export default function SafeImage({ src, category, alt = "", className = "", ...rest }) {
  const fallback = FALLBACKS[category] || DEFAULT_FALLBACK;
  const [current, setCurrent] = useState(src || fallback);
  const [failed, setFailed] = useState(false);

  const handleError = () => {
    if (current !== fallback) {
      setCurrent(fallback);
    } else {
      setFailed(true);
    }
  };

  if (failed) {
    return <div className={`${className} bg-gradient-to-br from-primary/25 to-secondary`} role="img" aria-label={alt} />;
  }

  return <img src={current} alt={alt} onError={handleError} className={className} {...rest} />;
}
